// Central data for the landing page. Easy to edit when real assets arrive.

export const AGENCY = {
    name: "IMPACTO VISUAL",
    tagline: "Creamos marcas que se ven.\nY se recuerdan.",
    whatsapp: "+56 9 5816 2861",
    whatsappUrl:
        "https://wa.me/56958162861?text=Hola%2C%20quiero%20una%20cotizaci%C3%B3n",
    email: "secretaria@impactovisual.cl",
    emailUrl: "mailto:secretaria@impactovisual.cl",
    instagram: "https://instagram.com/",
};

// Feed items — 6 video reels (vertical).
export const FEED_ITEMS = [
    {
        id: "f1",
        type: "video",
        title: "Libretas & Lápices",
        tag: "Personalización Corporativa",
        src: "https://customer-assets.emergentagent.com/job_agency-showcase-139/artifacts/fh226tq3_En%20La%20Serena%2C%20personalizamos%20libretas%2C%20l%C3%A1pices%20y%20accesorios%20corporativos%20con%20precisi%C3%B3n%20milim%C3%A9tri.mp4",
    },
    {
        id: "f3",
        type: "video",
        title: "Audiovisual",
        tag: "Reels de Producto",
        src: "https://customer-assets.emergentagent.com/job_agency-showcase-139/artifacts/ivant176_Somos%20Impacto%20Visual%2C%20tu%20agencia%20360%C2%B0%20de%20la%20IV%20regi%C3%B3n.mp4",
    },
    {
        id: "f4",
        type: "video",
        title: "Motion Graphics",
        tag: "Anuncios con IA",
        src: "https://customer-assets.emergentagent.com/job_agency-showcase-139/artifacts/xu602l4g_Reinventa%20tus%20anuncios%20con%20el%20poder%20de%20la%20IA.%20V%C3%ADdeos%20din%C3%A1micos%20y%20disruptivos%20que%20ponen%20a%20tu%20nego.mp4",
    },
    {
        id: "f5",
        type: "video",
        title: "Ploteo Vehicular",
        tag: "Branding Corporativo",
        src: "https://customer-assets.emergentagent.com/job_agency-showcase-139/artifacts/hi648q7n_Tu%20marca%20puede%20ser%20buena%2C%20pero%20si%20nadie%20la%20ve%20no%20vende.%20%F0%9F%9A%97%20Con%20ploteo%20vehicular%20de%20alta%20calidad%2C.mp4",
    },
    {
        id: "f8",
        type: "video",
        title: "Letras de Acero",
        tag: "Gran Formato",
        src: "https://customer-assets.emergentagent.com/job_agency-showcase-139/artifacts/fg63huyg_Si%20tu%20marca%20no%20impone%20presencia%2C%20est%C3%A1s%20perdiendo%20visibilidad.%20%F0%9F%93%89Nuestras%20letras%20de%20acero%20est%C3%A1n%20h.mp4",
    },
    {
        id: "f9",
        type: "video",
        title: "Motion Graphics",
        tag: "Videos Corporativos",
        src: "https://customer-assets.emergentagent.com/job_agency-showcase-139/artifacts/q9hjt2mi_Tu%20marca%20no%20solo%20necesita%20vender%2C%20necesita%20impactar.%20%E2%9C%A8En%20la%20Regi%C3%B3n%20de%20Coquimbo%2C%20la%20diferencia%20en.mp4",
    },
];

export const TESTIMONIALS = [
    {
        id: "t1",
        name: "María González",
        role: "Head of Marketing",
        company: "Nova Retail",
        quote: "Subieron nuestro CTR un 340%. El spot que hicieron es, literalmente, la mejor pieza que hemos sacado en 5 años.",
        rating: 5,
        avatar: "M",
    },
    {
        id: "t2",
        name: "Diego Fuentes",
        role: "Founder",
        company: "Meridian Coffee",
        quote: "Pedimos branding, nos entregaron una identidad que los clientes reconocen a dos cuadras. Trabajan como socios, no como proveedor.",
        rating: 5,
        avatar: "D",
    },
    {
        id: "t3",
        name: "Camila Ruiz",
        role: "Creative Director",
        company: "Atlas Studio",
        quote: "Rápidos, brutales con el concepto y obsesivos con el detalle. Nunca vi un equipo defender tanto una idea — y tener razón.",
        rating: 5,
        avatar: "C",
    },
    {
        id: "t4",
        name: "Tomás Vargas",
        role: "CEO",
        company: "Horizon Tech",
        quote: "Invertimos en ads con ellos y rompimos el ROAS objetivo en el primer mes. Lo que prometen, lo ejecutan.",
        rating: 5,
        avatar: "T",
    },
];

export const SERVICES = [
    {
        n: "01",
        name: "Diseño Gráfico",
        short: "Diseño",
        desc: "Piezas visuales con propósito. De lo digital a lo impreso.",
        bullets: ["Diseño Publicitario", "Piezas Gráficas de gran formato", "Branding", "Material POP"],
        turnaround: "1–2 semanas",
        priceFrom: "$1.0K",
    },
    {
        n: "02",
        name: "Diseño Web",
        short: "Web",
        desc: "Sitios web a medida, rápidos y pensados para convertir.",
        bullets: ["Landing pages", "Sitios corporativos", "E-commerce", "Optimización SEO"],
        turnaround: "2–4 semanas",
        priceFrom: "$1.8K",
    },
    {
        n: "03",
        name: "Social Media",
        short: "Social",
        desc: "Contenido pensado para detener el scroll.",
        bullets: ["Reels", "Estrategia mensual", "Copywriting", "Calendario editorial"],
        turnaround: "Ongoing",
        priceFrom: "$1.2K/mes",
    },
    {
        n: "04",
        name: "Activaciones de Marca",
        short: "Activaciones",
        desc: "Eventos y acciones BTL que llevan tu marca a la calle.",
        bullets: ["Eventos de marca", "Promotoras y BTL", "Volanteo", "Producción en terreno"],
        turnaround: "1–2 semanas",
        priceFrom: "$1.5K",
    },
    {
        n: "05",
        name: "Motion Graphics",
        short: "Motion",
        desc: "Animación 2D/3D, titulares y piezas para ads.",
        bullets: ["Logo reveal", "Explainer videos", "Ads animados", "Titulares"],
        turnaround: "1–3 semanas",
        priceFrom: "$1.8K",
    },
    {
        n: "06",
        name: "Campañas Digitales",
        short: "Digital",
        desc: "Estrategia, pauta y creatividad con foco en performance.",
        bullets: ["Meta / Google Ads", "Creatividad 360°", "Landing pages", "Reportes mensuales"],
        turnaround: "Ongoing",
        priceFrom: "$2.0K/mes",
    },
];

export const MARQUEE_WORDS = [
    "Diseño Gráfico",
    "Impresión",
    "Instalación",
    "Producción",
];

export const CLIENTS = [
    "Coca Cola",
    "Mall Plaza",
    "Chuck E Cheese",
    "Mi Radio",
    "Autoshopping",
    "Mall Puerta Del Mar",
    "Desco",
];
